import { ProductWizardNode, ProductWizardType, WizardOptions } from '../types'

export enum DuckFootStepNameForAnalytics {
  ChooseMake = 'Choose Make',
  ChooseModel = 'Choose Model',
  BattAndHeader = 'Batt & Header',
  Result = 'Result',
  Unknown = 'Unknown',
}

export type DuckFootWizardOptions = WizardOptions & {
  type: ProductWizardType.DuckFoot
  url: string | null
  quantity: number | null
  product_id: string | null
  sku_id: string | null
  card_id: string | null
}

export type DuckFootWizardNode = ProductWizardNode<ProductWizardType.DuckFoot>
